import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AccordionContent } from '../../models/accordion-content.model';

@Component({
  selector: 'vm-accordion-section',
  templateUrl: './accordion-section.component.html',
  styleUrls: ['./accordion-section.component.scss'],
})
export class AccordionSectionComponent {
  @Input() data: AccordionContent;
  @Output() ContentClick = new EventEmitter();

  public onContentClicked(type: string, eventParams: any) {
    this.ContentClick.emit({ type, eventParams });
  }
}
